import L from 'leaflet';
import JSZip from 'jszip';
import toKml from 'tokml';
import saveAs from 'file-saver';

const polygonFeature = (polygon, getFeature) => {
    let feature = getFeature && getFeature(polygon);
    if (!feature) {
        const rawPoints = getFeature ? polygon.points || polygon.points_place : polygon.points_place || polygon.points;
        if (rawPoints) {
            const points = typeof rawPoints === 'string' ? JSON.parse(rawPoints) : rawPoints;
            if (!Array.isArray(points) || points.length < 3) throw new Error('Invalid polygon geometry');
            feature = L.polygon(points).toGeoJSON();
        } else {
            feature = polygon.polygon;
        }
    }
    if (feature && feature.type === 'FeatureCollection' && feature.features.length === 1) feature = feature.features[0];
    if (!feature || !feature.geometry || !['Polygon', 'MultiPolygon'].includes(feature.geometry.type)) {
        throw new Error('Missing polygon geometry');
    }
    const parts = feature.geometry.type === 'Polygon' ? [feature.geometry.coordinates] : feature.geometry.coordinates;
    if (!Array.isArray(parts) || !parts.length || parts.some(rings => !Array.isArray(rings) || !rings.length ||
        rings.some(ring => !Array.isArray(ring) || ring.length < 4 || ring.some(point =>
            !Array.isArray(point) || point.length < 2 || !Number.isFinite(point[0]) || !Number.isFinite(point[1]))))) {
        throw new Error('Invalid polygon geometry');
    }
    const rawType = String(polygon.poly_type || polygon.type || '').toUpperCase();
    const type = rawType === 'C' ? 'F' : ['N', 'F', 'T', 'X', 'XL', 'R'].includes(rawType) ? rawType : polygon.x ? 'X' : 'N';
    const properties = { name: polygon.name || '', type, guid: polygon.guid || polygon.id || '' };
    if (type === 'N' && polygon.ab) {
        try {
            const ab = typeof polygon.ab === 'string' ? JSON.parse(polygon.ab) : polygon.ab;
            if (Array.isArray(ab) && ab.length === 2 && ab.every(point =>
                Array.isArray(point) && point.length === 2 && point.every(Number.isFinite))) {
                properties.ab = JSON.stringify(ab);
            }
        } catch (error) { /* Ignore an invalid optional AB without dropping the polygon. */ }
    }
    return { type: 'Feature', geometry: feature.geometry, properties };
};

export default async function downloadPolygons(polygons, getFeature) {
    if (!polygons.length) return;
    const features = polygons.map(polygon => polygonFeature(polygon, getFeature));
    const zip = new JSZip();
    zip.file('doc.kml', toKml({ type: 'FeatureCollection', features }));
    const content = await zip.generateAsync({ type: 'blob', compression: 'DEFLATE', compressionOptions: { level: 4 } });
    saveAs(content, 'areas.kmz');
}
